
import Vue from 'vue';
import ProgressBar from './progress/ProgressBar.vue';

import i18n from '../i18n';
import { Icon } from '@descomplica/vue-components';
import ShowCaseCard from '@/components/ShowCaseCard.vue';
import { TRIAL_SHOW_CASE_COURSES } from '@/enum/trial/trialShowCaseCourses.enum';
import { TRIAL_SHOW_CASE_STEPS } from '@/enum/trial/trialShowCaseSteps.enum';
import { ShowCaseHelper } from '@/helpers/trial';

interface Data {
  showContent: boolean;
  showCaseHasFinished: boolean;
  progressValue: number;
}

export interface ShowCaseUrl {
  selectiveProcess?: string;
  course?: string;
  firstClassroomUrl?: string;
}

export interface ShowCaseCards {
  icon: string;
  bottomBarColor: string;
  title: string;
  type: TRIAL_SHOW_CASE_STEPS;
  urls: ShowCaseUrl[];
}

export default Vue.extend({
  i18n,
  components: {
    Icon,
    ShowCaseCard,
    ProgressBar,
  },
  props: {
    currentCourseSlug: {
      type: String,
      required: true,
      validator(value: string) {
        const showCaseCourses: string[] = Object.values(TRIAL_SHOW_CASE_COURSES);
        return showCaseCourses.includes(value);
      },
    },
  },
  data(): Data {
    return {
      showContent: true,
      showCaseHasFinished: false,
      progressValue: 0,
    };
  },
  computed: {
    getShowCaseData(): any {
      return this.$t('trial.showCase');
    },
    showCaseCards(): ShowCaseCards[] {
      return this.getShowCaseData.cards as ShowCaseCards[];
    },
    getCurrentPeriodByEnrollmentStartDate(): number {
      const enrollmentStartDate = this.$store.getters.currentUser.enrollments[0].createdAt;
      return ShowCaseHelper.getCurrentPeriodByEnrollmentStartDate(enrollmentStartDate);
    },
  },
  mounted() {
    this.showCaseHasFinished = ShowCaseHelper.showCaseHasFinished();
    this.setProgress();
  },
  methods: {
    setProgress() {
      this.progressValue = ShowCaseHelper.percentageOfSteps();
    },
    finishShowCase(): void {
      ShowCaseHelper.finishShowCase();
      this.showCaseHasFinished = ShowCaseHelper.showCaseHasFinished();
    },
    enter(element: HTMLElement) {
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const { height } = getComputedStyle(element);

      element.style.visibility = 'visible';
      element.style.height = '0';

      getComputedStyle(element);

      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element: HTMLElement) {
      element.style.height = 'auto';
    },
    leave(element: HTMLElement) {
      const { height } = getComputedStyle(element);

      element.style.height = height;

      getComputedStyle(element);

      requestAnimationFrame(() => {
        element.style.height = '0';
      });
    },
  },
});
